import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ApplicationContext } from '../../context/GlobalState';
import { t, extractLocaleFromPath, localizedPath } from '../../i18n';

export default function Locations() {
  const { state } = useContext(ApplicationContext);
  const location = useLocation();
  const { locale } = extractLocaleFromPath(location.pathname);
  const brand = state.brand;
  const allLocations = state.taxonomy?.dimensions?.find(d => d.id === 'location')?.values || [];
  
  // Filter to brand locations
  const brandLocations = allLocations.filter(loc => 
    brand.locations?.includes(loc.slug) || loc.brand === brand.brandKey
  );

  return (
    <div className="locations-index">
      <section className="glass-dark" style={{ padding: '60px 0', textAlign: 'center', borderRadius: 0, marginBottom: 40 }}>
        <div className="container">
          <h1>{t('nav.locations', locale)}</h1>
          <p style={{ opacity: 0.9 }}>{brand.name} — {brandLocations.length} Locations</p>
        </div>
      </section>
      <section className="container" style={{ maxWidth: 1000, margin: '0 auto', padding: '0 20px 60px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 20 }}>
          {brandLocations.map((loc, i) => (
            <Link key={i} to={localizedPath(`/${loc.slug}`, locale)} className="glass-card" style={{ padding: 24, textDecoration: 'none', color: 'var(--color-text)' }}>
              <h3 style={{ fontSize: '1.3rem', marginBottom: 8 }}>{loc.city}, {loc.state}</h3>
              {loc.address && <p style={{ color: 'var(--color-text-secondary)', fontSize: '0.9rem', marginBottom: 12 }}>{loc.address}</p>}
              <span style={{ color: 'var(--color-accent)', fontWeight: 600 }}>{t('cta.learnMore', locale)} →</span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
